import { useState } from "react";
import styles from "../ForgotPassword.module.scss";
import { Button } from "../../../components";
import { AuthContainer } from "../../../components/AuthContainer/AuthContainer";
import { InputPassword } from "../../../components/ui/InputPassword/InputPassword";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../helpers/routes";

export const ForgotPasswordCode = () => {
  const [code, setCode] = useState("");
  const navigate = useNavigate();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!code) {
      return;
    }
    navigate(`${ROUTES.setPassword}`);
  };

  return (
    <AuthContainer
      title="Verify code"
      subtitle="An authentication code has been sent to your email."
    >
      <form action="POST" className={styles.form} onSubmit={handleSubmit}>
        <div>
          <InputPassword
            value={code}
            setValue={setCode}
            id="code"
            type="code"
            label="Enter Code"
            placeholder="123456"
            required
            minLength={6}
            pattern="[0-9]+"
            title="please enter number only"
          />
          <p className={styles.signupText}>
            Didn’t receive a code?{" "}
            <button
              className={styles.link}
              type="button"
              onClick={() => console.log("fixme")}
            >
              Resend
            </button>
          </p>
        </div>
        <Button type="submit" disabled={code.length !== 6}>
          Verify
        </Button>
      </form>
    </AuthContainer>
  );
};
